import { AssetHeadlineFigure } from "@hydrologiq/gql-experience/graphql"
import Figure from "@hydrologiq/shared/figures/generic/Figure"
import FigureContent from "@hydrologiq/shared/figures/generic/FigureContent"

interface HybridBatteryLevelFigureProps {
  data?: AssetHeadlineFigure
  loading?: boolean
  error?: string
  isPlaceholder?: boolean
  compact?: boolean
}

function HybridBatteryLevelFigure({
  data,
  loading,
  error,
  isPlaceholder,
  compact = true,
}: HybridBatteryLevelFigureProps) {
  const value = data?.value ?? 0

  return (
    <Figure
      heading={data?.label ?? "Battery Level"}
      isPlaceholder={!data?.available || error !== undefined || isPlaceholder}
      loading={loading}
      error={error}
      compact={compact}
    >
      <FigureContent.Root compact={compact}>
        <FigureContent.SubText compact={compact}>current</FigureContent.SubText>
        <FigureContent.Value compact={compact}>
          {`${value.toFixed(1)}%`}
        </FigureContent.Value>
      </FigureContent.Root>
    </Figure>
  )
}

export default HybridBatteryLevelFigure
